import { EAdminRoutes } from '@/services/router/enums';

export const ROUTES_TITLES = new Map<EAdminRoutes, string>([
    [EAdminRoutes.Dashboard, 'Dashboard'],
    [EAdminRoutes.Login, 'Login'],
    [EAdminRoutes.NotFoundException, 'Not Found'],
    [EAdminRoutes.Practices, 'Practices'],
    [EAdminRoutes.Customers, 'Customers'],
    [EAdminRoutes.Patients, 'Patients'],
    [EAdminRoutes.Admins, 'Admins'],
]);
